import React from 'react';
import './styles.css';
import { SettingOutlined } from '@ant-design/icons';

const WorkingMessage = ({ message }) => {
  return (
    <div className="working-message-container">
      <div className="icon-wrapper">
        <SettingOutlined spin />
      </div>
      <div className="text-wrapper">
        <h2>{message}</h2>
      </div>
    </div>
  );
};

export default WorkingMessage;
